module.exports = __webpack_public_path__ + "static/best-meets-requirements-small-business-2022-36df859bec71384265502c3d15e7ed76.svg";